/* eslint-disable react/react-in-jsx-scope */
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from "react-router"
import CurrentUser from './currentUser'

const navigation = [
  { name: 'Dashboard', href: '/pos/dashboard'},
  { name: 'Invoice', href: '/pos/invoices'},
  { name: 'User', href: '/users'},
  { name: 'Products', href: '/products'},
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function NavbarAuth() {

  return (
      <div  className="flex w-full fixed top-0 z-30 items-center justify-between  text-lg h-16 text-slate-400 p-2 px-4 bg-slate-900 ">
        <div className="flex items-center  hover:rounded-md">
          <a href="/" alt="Home">
            <img alt="Online Market" className="w-[200px] sm:w-[250px] p-1 pl-6 sm:pl-1 rounded-xl"
              src="/logo-720.png" 
            />
          </a>
        </div>
        {/* <div className="mr-auto justify-center ">
          <div className="hidden md:ml-6 md:block">
            <div className="flex space-x-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  aria-current={item.current ? 'page' : undefined}
                  className="text-gray-300 rounded-md px-3 py-2 text-sm font-medium hover:border-b-2 hover:border-slate-400  hover:text-teal-500 "
                  // className={classNames(
                  //   item.current ? 'bg-teal-900 text-white' : 'text-gray-300 hover:border-b-2 hover:border-slate-400  hover:text-teal-500 ',
                  //   'rounded-md px-3 py-2 text-sm font-medium',
                  // )}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        </div> */}
        <div className="flex items-center justify-between">
          <CurrentUser  />
        </div>
      </div>




    
  )
}
